import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { deleteBooking } from "../../services/bookingService";
import SuccessMessageModal from "../Reusable/SuccessMessageModal";
import WarningMessageModal from "../Reusable/WarningMessageModal";

const DeleteBookingModal = ({ isOpen, onClose, booking }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await deleteBooking(booking.booking_id);
      setModalMessage("Reserva eliminada exitosamente.");
      setIsSuccessOpen(true);
    } catch (error) {
      const errorMessage = error.response?.data?.detail || "Error al eliminar la reserva.";
      setModalMessage(errorMessage);
      setIsWarningOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessOpen(false);
    onClose(true); // Indicar que se debe refrescar
  };

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)}>
      <DialogTitle>Confirmar Eliminación</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box display="flex" justifyContent="center"><CircularProgress /></Box>
        ) : (
          <Typography>
            ¿Estás seguro de que deseas eliminar la reserva para el vehículo con placa{" "}
            <strong>{booking?.plate}</strong> en la celda <strong>{booking?.location}</strong>?
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>Cancelar</Button>
        <Button onClick={handleConfirm} color="error" variant="contained" disabled={isLoading}>
          Eliminar
        </Button>
      </DialogActions>
      <SuccessMessageModal isOpen={isSuccessOpen} message={modalMessage} onClose={handleSuccessClose} />
      <WarningMessageModal isOpen={isWarningOpen} message={modalMessage} onClose={() => setIsWarningOpen(false)} />
    </Dialog>
  );
};

export default DeleteBookingModal;
